import { GlobalResponseObject } from "../../global-response-object";
import { TotalVOBandVolyDetails } from "./totalVOBandVOLY-Details";


export class TotalVOBandVolyDetailsResponse extends GlobalResponseObject{
data?:TotalVOBandVolyDetails[];
constructor(status: boolean, intlCode: number, internalMessage: string, data?:TotalVOBandVolyDetails[]){
    super(status,intlCode,internalMessage)
    this.data = data;
}
}